const cores = {
    agendado:   { bg: '#EBF5FB', cor: '#1A5276', texto: 'Agendado'   },
    confirmado: { bg: '#EAF7EA', cor: '#1E8449', texto: 'Confirmado' },
    retirado:   { bg: '#F4F6F7', cor: '#566573', texto: 'Retirado'   },
    cancelado:  { bg: '#FDEDEC', cor: '#922B21', texto: 'Cancelado'  },
};

export default function StatusBadge({ status }) {
    const c = cores[status] || cores.agendado;
    return (
        <span style={{
            background:   c.bg,
            color:        c.cor,
            padding:      '3px 10px',
            borderRadius: '12px',
            fontSize:     '12px',
            fontWeight:   '600',
        }}>
            {c.texto}
        </span>
    );
}
